import {FormFieldValidationResult} from '@mintdata-wsp/common/components/form/Form';
import {computed, observable} from 'mobx';

export enum PublishMode
{
    Public = 'PUBLIC',
    UniqueLink = 'UNIQUE_LINK',
    MintDataLogin = 'MINTDATA_LOGIN',
    MintDataOrganizationLogin = 'MINTDATA_ORGANIZATION_LOGIN',
    CorporateSSO = 'CORPORATE_SSO'
}

export class DesignRef
{
    constructor(public readonly projectId:number,
                public readonly designId:number,
                public designName:string,
                public version:number,
                public uuid:string)
    {
    }
}

export class PublishUIRequest
{
    @observable
    public mode:PublishMode = null;

    @observable
    public urlPart:string = null;

    @observable
    public betaUrlPart:string = null;

    @observable
    public isBeta:boolean = false;

    @observable
    public cnameHostname:string = null;

    @computed
    get currentUrlPart()
    {
        return this.isBeta ? this.betaUrlPart : this.urlPart;
    }

    // Note: this is not an observable, just used to pass
    // state to PublishController from various parts of the UI
    public designRef:DesignRef = null;
}

export enum CNameMappingStatus
{
    NotPresentInCustomerDNS = 'NotPresentInCustomerDNS',
    OurSetupInProgress = 'OurSetupInProgress',
    Done = 'Done',
    ErrorContactSupport = 'ErrorContactSupport'
}

export enum PublishStatus
{
    CheckingUrl = 'CHECKING_URL',
    SavingDesign = 'SAVING_DESIGN',
    Scheduled = 'SCHEDULED',
    Preparing_Assets = 'PREPARING_ASSETS',
    Deploying_Topology = 'DEPLOYING_TOPOLOGY',
    Running = 'RUNNING',
    Failed = 'FAILED',
    Stopping = 'STOPPING',
    Stopped = 'STOPPED',
    Stop_Failed = 'STOP_FAILED'
}

export enum PublishVersion
{
    Main = 'MAIN',
    Beta = 'BETA',
}

export enum ConnectDomainState
{
    Default = 0,
    DomainAdded = 1,
    Checking = 2,
    Failure = 3,
    Confirmed = 4
}

export class PublishProgressState
{
    @observable
    isPublishInProgress:boolean = false;

    @observable
    publishProgressMessage:string = null;

    @observable
    hadErrorDuringPublish:boolean = false;

    @observable
    isPublished:boolean = false;
}

export class PublishState
{
    public request:PublishUIRequest = new PublishUIRequest();

    public progress:PublishProgressState = new PublishProgressState();

    public membersToInvite:Array<string> = [];

    @observable
    public isConnectDomainMode:boolean = false;

    @observable
    public connectDomainState:ConnectDomainState = ConnectDomainState.Default;

    // @observable
    public domainValidationResult:FormFieldValidationResult = null;

    @observable
    public cnameHostname:string = null;

    @observable
    public cnameCheckId:string = null;

    @observable
    public shouldSaveBeforePublish:boolean = false;
}
